module.exports = __webpack_public_path__ + "static/media/code_by_price.a8c0f647.svg";